import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
//import React from 'react';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import {store} from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Toast } from './components/Toast';
import { createTheme, MantineProvider } from '@mantine/core';
import ProtectedRoute from './pages/ProtectedRoute'
import MainLayout from './pages/MainLayout';
import CheckoutPage from './pages/CheckoutPage';
import CheckoutSuccesPage from './pages/CheckoutSuccesPage';
import Preloader from './components/Preloader';
import PaymentProcess from './pages/PayPage';

const theme = createTheme({
  fontFamily: 'Montserrat, serif',
  headings: { fontFamily: 'Bebas Neue, serif' },
  components: {
    Input: {
      styles: {
        input: { fontSize: '16px' },
      },
    },
  },
});

const App = () => {

  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    const timeout = () => setTimeout(() => {
      setFontsLoaded(true);
    }, 5000);

    document.fonts.ready.then(() => {
      timeout()
    });
  }, []);

  return (
    <MantineProvider theme={theme} withGlobalStyles withNormalizeCSS > 
      <Provider store={store}>
        {!fontsLoaded ? <Preloader loaderMessage='Lo estamos dirigiendo a la pasarela de preinscripción UAI'/> : (
          <Router>
            <Toast />
            <Routes>
              <Route path="/" element={<ProtectedRoute element={<MainLayout />}/>}>
                <Route index element={< CheckoutPage />} />
                <Route path="success" element={< CheckoutSuccesPage />} />
                <Route path="payment" element={< PaymentProcess />} />
              </Route>
            </Routes>
          </Router>
        )}
      </Provider>
    </MantineProvider>
  );
};

export default App;
